<template>
  <div class="vh-100 overflow-hidden">
    <iframe v-if="previewUrl" class="w-100 h-100" :src="previewUrl" frameBorder="0"></iframe>

    <div v-else class="app flex-row align-items-center h-100">
      <div class="container">
        <div v-if="isLoading" class="row justify-content-center">
          <div class="col-md-5">
            <div class="clearfix">
              <h4 class="pt-3">Please wait while loading your file...</h4>
            </div>
          </div>
          <div class="col-md-1 inlineSpinner"></div>
        </div>

        <div v-else class="row justify-content-center">
          <div class="col-md-6">
            <div class="clearfix">
              <h4 class="pt-3">Download nicht vorhanden</h4>
              <p>Sie können Ihre Ergebnisse stets in Ihrem MSMloop Konto finden. Der Download Link zu diesem Check Report
                ist aus Sicherheitsgründen abgelaufen oder das Ergebnis ist nicht mehr verfügbar.</p>

              <h4 class="pt-3">Download not available</h4>
              <p>Please check your MSMloop account for all your results. The download link to this Check Report has expired
                for security reasons or this result is not available anymore.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DownloadService from '@/services/DownloadService';

export default {
  name: 'Download',

  data() {
    return {
      previewUrl: null,
      isLoading: false
    }
  },

  mounted() {
    this.showPreview();
  },

  methods: {
    showPreview() {
      this.isLoading = true;

      DownloadService.getDownloadFile(this.$route.params.token)
        .then((response) => {
          this.isLoading = false;

          const blobUrl = window.URL.createObjectURL(response.data);
          this.previewUrl =`${process.env.BASE_URL}static/pdfjs/web/viewer.html?file=${blobUrl}`;
        })
        .catch((thrown) => {
          this.isLoading = false;
        });
    }
  }
}
</script>
